module.exports = __webpack_public_path__ + "img/iconfont.e8f25eb9.svg";